import React, { Fragment, useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AiFillFunnelPlot } from 'react-icons/ai';
import TFSegment from '../TFSegment';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CallIcon from '@mui/icons-material/Call';
import TaskIcon from '@mui/icons-material/Task';
import DeleteIcon from '@mui/icons-material/Delete';
import { update } from '../../../common/api';
import { ObjModal } from '../../../contexts';
import AddTaskFollowUp from '../../Modals/AddTaskFollowUp';
import '../../../containers/Dashboard/dashboard.css';
import { isNextMonth, isNextWeek, isThisMonth, isThisWeek, isToday, isTomorrow } from '../../../common/utils';
import Comms from '../Comms';


const Work = ( { title, org, orgId, aid, uid, viewing, meta, contacts, tasks, gameplan, loans, leadopps, comms, loanStatus, globalStatus, e } ) => {
    const [ plan, setPlan ] = useState( [] );
    const [ planOpen, setPlanOpen ] = useState( 0 );
    const [ planCompleted, setPlanCompleted ] = useState( 0 );

    const [ manual, setManual ] = useState( [] );
    const [ manualOpen, setManualOpen ] = useState( 0 );
    const [ manualCompleted, setManualCompleted ] = useState( 0 );

    const [ insights, setInsights ] = useState( [] );
    const [ insightsOpen, setInsightsOpen ] = useState( 0 );
    const [ insightsCompleted, setInsightsCompleted ] = useState( 0 );

    const { openModal, closeModal, setModal } = useContext( ObjModal );
    
    const markComplete = async ( oid ) => {
        const objType = ( oid.match( /^gp/ ) ) ? 'gameplan' : 'task';
        const cd = new Date();
        const updated = await update( orgId, aid, uid, objType, oid, { status: 'Completed', completedDate: cd.toJSON() } );
        if ( updated.length ) {
            handleSingleModal( 'follow-up-task', oid );
        }
    }

    const actionsGP = [
        { icon: <CallIcon />, label: 'Log a Call', type: 'log-call', onSave: markComplete },
        { icon: <TextsmsIcon />, label: 'Log a Txt', type: 'log-sms', dropdown: true, onSave: markComplete },
        { icon: <EmailIcon />, label: 'Log an Email', type: 'log-email', dropdown: true, onSave: markComplete },
        // { icon: <ScheduleIcon />, label: 'Remind Me Tomorrow', type: 'reschedule', dropdown: true },
    ];

    const actionsTasks = [
        { icon: <CallIcon />, label: 'Log a Call', type: 'log-call', onSave: markComplete },
        { icon: <TextsmsIcon />, label: 'Log a Txt', type: 'log-sms', dropdown: true, onSave: markComplete },
        { icon: <EmailIcon />, label: 'Log an Email', type: 'log-email', dropdown: true, onSave: markComplete },
        // { icon: <ScheduleIcon />, label: 'Remind Me Tomorrow', type: 'reschedule', dropdown: true },
        // { icon: <TaskIcon />, label: 'Mark Completed', type: 'task-complete', dropdown: true },
    ];

    const actionsInsights = [
        { icon: <CallIcon />, label: 'Log a Call', type: 'call-log' },
        { icon: <EmailIcon />, label: 'Send Email', type: 'email', dropdown: true },
        { icon: <TextsmsIcon />, label: 'Send Txt', type: 'txt', dropdown: true },
        { icon: <ScheduleIcon />, label: 'Remind Me Tomorrow', type: 'reschedule', dropdown: true },
        { icon: <TaskIcon />, label: 'Mark Completed', type: 'task-complete', dropdown: true },
        { icon: <DeleteIcon />, label: 'Ignore this Insight', type: 'insight-ignore', dropdown: true }
    ];

    const [ elements, setElements ] = useState( [ 'gameplans', 'tasks', 'insights' ] );
    const [ data, setData ] = useState( {
        gameplans: { chartTitle: '0 : 0',  chartSub: 'Done', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "Today's Calls", gridData: [], gridActions: actionsGP, gridExport: false },
        tasks: { chartTitle: '0 : 0',  chartSub: 'Done', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "Today's Tasks", gridData: [], gridActions: actionsTasks, gridExport: false },
        // insights: { chartTitle: '0 : 0',  chartSub: 'Done', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "Today's Insights", gridData: [], gridActions: [], gridExport: false },
        insights: { chartTitle: '0',  chartSub: 'Open Txts', chartData: [ { name: "Open Txts", value: 0 } ], gridTitle: "Txt Msgs", gridData: [], gridActions: [], gridExport: false },
        bdays: { chartTitle: '0',  chartSub: 'Bdays', chartData: [ { name: "Bdays", value: 0 } ], gridTitle: "Birthdays", gridData: [], gridActions: [], gridExport: true },
        stalled: { chartTitle: '0',  chartSub: 'Loans', chartData: [ { name: "Loans", value: 0 } ], gridTitle: "Stalled Loans", gridData: [], gridActions: [], gridExport: true },
        insights2: { chartTitle: '0',  chartSub: 'Signals', chartData: [ { name: "Insight Signals", value: 0 } ], gridTitle: "Insight Signals", gridData: [], gridActions: [], gridExport: false },
        // appsrequested: { chartTitle: '0 : 0',  chartSub: 'Requested', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "Apps Requested", gridData: [], gridActions: [] },
        // setup: { chartTitle: '0 : 0',  chartSub: 'In Setup', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "In Setup", gridData: [], gridActions: [] },
        // pareview: { chartTitle: '0 : 0',  chartSub: 'In Review', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "PA Reviews", gridData: [], gridActions: [] },
        // active: { chartTitle: '0 : 0',  chartSub: 'In Process', chartData: [ { name: "Completed", value: 0 }, { name: "Remaining", value: 0 } ], gridTitle: "Loans in Process", gridData: [], gridActions: [] }
    } );
    
    const taskToCopy = ( oid ) => {
        let t = {};
        if ( oid.match( /^task/ ) ) {
            console.log( 'task: ', tasks[oid] );
            t = {
                details: tasks[oid],
                associations: tasks[oid].assoc
            }
        } else {
            const gp = gameplan[oid];

            t['details'] = {
                name: 'Follow-up on: ' + gp.reason,
                // details: '',
                priority: 'Normal',
                assignedTo: gp.assignedTo,
                type: 'Call'
            };
            t['associations'] = [ { cid: gp.cid } ]
        }
        return t;
    }

    const handleSingleModal = ( t, oid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'follow-up-task':
                const task = taskToCopy( oid );
                console.log( 'follow-up-task w/ oid: ' + oid );
                console.log( 'copy task: ', task );
                
                setModal( <AddTaskFollowUp close={closeModal} copy={task} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + oid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const calcDuration = ( start ) => {
        let duration = 0;

        if ( start ) {
            const now = new Date();
            const d = new Date( start );
            duration = now.getTime() - d.getTime();
        }

        return duration;
    }

    const calcSince = ( start, priority ) => {
        let duration = 'at an unknown time';

        if ( priority === 'High' ) {
            duration = 'Flagged as High Priority!';
        } else if ( start ) {
            const now = new Date();
            const d = new Date( start );
            const diff = now.getTime() - d.getTime();
            let hrs = diff / ( 1000 * 60 * 60 );
            hrs = Math.round( hrs * 100 ) / 100
            duration = hrs + ' hrs ago';
        }

        return duration;
    }

    const formatDate = ( date ) => {
        let now = new Date();
        let today = new Date( now.getFullYear(), now.getMonth(), now.getDate() );
        let yesterday = new Date( now.getFullYear(), now.getMonth(), now.getDate() - 1 );
    
        if ( date >= today ) {
            // If the date is today, return the time
            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            let strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        } else if ( date >= yesterday ) {
            // If the date is yesterday, return 'yesterday'
            return "Yesterday";
        } else {
            // If the date is prior to yesterday, return date in 'm/d/yy' format
            let year = date.getFullYear().toString().substr( -2 );
            let month = ( date.getMonth() + 1 ).toString();
            let day = date.getDate().toString();
    
            // Ensure double digit format
            month = month.length === 1 ? '0' + month : month;
            day = day.length === 1 ? '0' + day : day;
    
            return `${month}/${day}/${year}`;
        }
    }

    // Set Elements for Display
    useEffect( () => {
        if ( meta?.home?.details ) {
            console.log( 'meta home details: ', meta.home.details );
            let els = [];
            const work = meta.home.details.find( f => f.comp === 'work' );
            if ( work && work.segments && work.segments.length ) {
                work.segments.forEach( seg => {
                    els.push( seg.type );
                    setData( ( prev ) => {
                        return {
                            ...prev,
                            [seg.type]: {
                                ...prev[seg.type],
                                gridTitle: seg.title
                            }
                        }
                    } );
                } );
                setElements( els );
            }
        }
    }, [ meta ] );

    useEffect( () => {
        console.log( 'e: ', e );
        if ( e && e.queues ) {
            setElements( e.queues );
        }
    }, [ e ] );

    // Gameplans
    useEffect( () => {
        let list = [];
        let open = 0;
        let completed = 0;
        const today = new Date();

        if ( tasks ) {
            Object.keys( tasks ).forEach( f => {
                const t = tasks[f];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                if ( !t.dueDate ) {
                    return;
                }
                if ( t && t.assignedTo === uid && t.type === 'Call' && Date.parse( t.dueDate ) <= Date.now() ) {
                    if ( [ 'Open', 'Not Started' ].includes( t.status ) ) {
                        open++;
                    // const [ yr, mon, d ] = t.dueDate.split( '-' );
                    // if ( parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                        const ta = ( t.assoc ) ? t.assoc[0] : null;
                        const c = contacts[ta?.cid];
                        if ( c ) {
                            list.push( {
                                id: t.tid,
                                oid: t.tid,
                                title: c.name,
                                sub: t.name,
                                c: c
                            } );
                        }
                    } else if ( t.status === 'Completed' && t.completedDate ) {
                        const cd = t.completedDate?.split( 'T' )[0];
                        const [ yr, mon, d ] = cd?.split( '-' );
                        if ( parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                            completed++;
                        }
                    }
                }
            } );
        }

        if ( gameplan ) {
            Object.keys( gameplan ).forEach( f => {
                const gp = gameplan[f];
                if ( !viewing.includes( gp.aid ) ) {
                    return;
                }

                const [ yr, mon, d ] = gp.dueDate.split( '-' );
                if ( gp && gp.assignedTo === uid && parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                    if ( gp.status === 'Open' ) {
                        const c = contacts[gp.cid];
                        if ( c ) {
                            open++;
                        
                            list.push( {
                                id: gp.gpid,
                                oid: gp.gpid,
                                title: c.name,
                                sub: gp.reason,
                                c: c
                            } );
                        }
                    } else if ( gp.status === 'Completed' ) {
                        completed++;
                    }
                }
            } );
        }
        setPlanCompleted( completed );
        setPlanOpen( open );
        const chartData = [
            { name: "Completed", value: completed },
            { name: "Remaining", value: open }
        ];

        list.sort( ( a, b ) => {
            const aid = a.id.split( '_' )[0];
            const bid = b.id.split( '_' )[0];

            // both are same type - either gp or task
            if ( aid === bid ) {
                if ( aid === 'task' ) {
                    const at = tasks[a.id];
                    const bt = tasks[b.id];
                    const add = new Date( at.dueDate );
                    const bdd = new Date( bt.dueDate );

                    return add.getTime() - bdd.getTime();
                }
                // must both be gameplans - push bdays to the top
                if ( a.sub === b.sub ) {
                    return 0;
                }
                if ( b.sub === 'Birthday Call' ) {
                    return 1;
                }
                if ( a.sub === 'Birthday Call' ) {
                    return -1;
                }

                return b.sub.localeCompare( a.sub );
            }
            
            if ( bid === 'task' ) {
                return 1;
            }
            
            return -1;
        } );
        setPlan( list );
        setData( ( prev ) => {
            return {
                ...prev,
                gameplans: {
                    ...prev.gameplans,
                    chartTitle: `${completed} : ${open + completed}`,
                    chartData: chartData,
                    gridData: list
                }
            };
        } );
    }, [ tasks, gameplan, contacts, uid, viewing ] );

    // Tasks
    useEffect( () => {
        let list = [];
        let open = 0;
        let completed = 0;
        const today = new Date();

        if ( tasks ) {
            Object.keys( tasks ).forEach( f => {
                const t = tasks[f];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                if ( t && t.assignedTo === uid ) {
                    if ( [ 'Open', 'Not Started' ].includes( t.status ) ) {
                        if ( !t.dueDate ) {
                            return;
                        }
                        if ( Date.parse( t.dueDate ) <= Date.now() ) {
                            open++;
                            const ta = ( t.assoc ) ? t.assoc[0] : null;
                            const c = contacts[ta?.cid];
                            if ( c ) {
                                list.push( {
                                    id: t.tid,
                                    oid: t.tid,
                                    title: c.name,
                                    sub: t.name,
                                    c: c
                                } );
                            }
                        }   
                    } else if ( t.status === 'Completed' && t.completedDate ) {
                        const cd = t.completedDate?.split( 'T' )[0];
                        const [ yr, mon, d ] = cd?.split( '-' );
                        if ( parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                            completed++;
                        }
                    }
                }
            } );
        }

        setManualCompleted( completed );
        setManualOpen( open );
        const chartData = [
            { name: "Completed", value: completed },
            { name: "Remaining", value: open }
        ];

        setManual( list );
        setData( ( prev ) => {
            return {
                ...prev,
                tasks: {
                    ...prev.tasks,
                    chartTitle: `${completed} : ${open + completed}`,
                    chartData: chartData,
                    gridData: list
                }
            };
        } );
    }, [ tasks, contacts, uid, viewing ] );
    
    // Insights
    useEffect( () => {
        let list = [];
        let open = 0;
        let completed = 0;
        const today = new Date();

        setInsightsCompleted( completed );
        setInsightsOpen( open );
        const chartData = [
            { name: "Completed", value: completed },
            { name: "Remaining", value: open }
        ];

        setInsights( list );
        setData( ( prev ) => {
            return {
                ...prev,
                insights1: {
                    ...prev.insights1,
                    chartTitle: `${completed} : ${open + completed}`,
                    chartData: chartData,
                    gridData: list
                },
                insights2: {
                    ...prev.insights2,
                    chartTitle: `${completed} : ${open + completed}`,
                    chartData: chartData,
                    gridData: list
                },
                stalled: {
                    ...prev.stalled,
                    chartTitle: `${completed} : ${open + completed}`,
                    chartData: chartData,
                    gridData: list
                }
            };
        } );
    }, [ contacts, uid, viewing ] );

    // Birthdays
    useEffect( () => {
        let list = [];

        if ( e && e.queues && e.queues.includes( 'bdays' ) ) {
            const timing = ( e.logic && e.logic.bdays && e.logic.bdays.timing ) ? e.logic.bdays.timing : 'Today';
            const segment = ( e.logic && e.logic.bdays && e.logic.bdays.segment ) ? e.logic.bdays.segment : 'all';

            if ( contacts ) {
                const sharePartners = ( org && org.sharePartners === true ) ? true : false;
                
                Object.keys( contacts ).forEach( cid => {
                    const c = contacts[cid];
                    if ( !( ( c.priRole === 'partner' && sharePartners ) || viewing.includes( c.aid ) ) ) {
                        return;
                    }

                    if ( c && c.birthday ) {
                        let add = false;
                        
                        // check timing...
                        switch ( timing ) {
                            case 'Today':
                                if ( isToday( c.birthday, true ) ) {
                                    console.log( c.name + ' is today!' );
                                    add = true;
                                }
                                break;

                            case 'Tomorrow':
                                if ( isTomorrow( c.birthday, true ) ) {
                                    add = true;
                                }
                                break;

                            case 'This Week':
                                if ( isThisWeek( c.birthday, true ) ) {
                                    add = true;
                                }
                                break;

                            case 'Next Week':
                                if ( isNextWeek( c.birthday, true ) ) {
                                    add = true;
                                }
                                break;

                            case 'This Month':
                                if ( isThisMonth( c.birthday, true ) ) {
                                    add = true;
                                }
                                break;

                            case 'Next Month':
                                if ( isNextMonth( c.birthday, true ) ) {
                                    add = true;
                                }
                                break;

                            default:
                                console.log( 'Unknonw bday timing: ' + timing );
                        }

                        // check segment...
                        if ( add ) {
                            switch ( segment ) {
                                case 'borrowers':
                                    if ( c.priRole !== 'borrower' ) {
                                        add = false;
                                    }
                                    break;

                                case 'partners':
                                    if ( c.priRole !== 'partner' ) {
                                        add = false;
                                    }
                                    break;

                                case 'associates':
                                    if ( c.priRole !== 'associate' ) {
                                        add = false;
                                    }
                                    break;

                                case 'closed':
                                    let hasClosed = false;
                                    if ( loans ) {
                                        Object.keys( loans ).forEach( lid => {
                                            const l = loans[lid];
                                            if ( l.status === 'Funded' && l.borrowers && l.borrowers.find( f => f.cid === cid ) ) {
                                                hasClosed = true;
                                            }
                                        } );
                                    }
                                    add = hasClosed;
                                    break;

                                case 'all':
                                    break;

                                default:
                                    console.log( 'Unknown bday segment: ' + segment );
                            }
                        }

                        // add to list...
                        if ( add ) {
                            let addr = '~ missing address ~';
                            if ( c.mailingAddress1 ) {
                                addr = c.mailingAddress1 + ', ' + c.mailingCity + ' ' + c.mailingState + ' ' + c.mailingZip;
                            } else if ( c.homeAddress1 ) {
                                addr = c.homeAddress1 + ', ' + c.homeCity + ' ' + c.homeState + ' ' + c.homeZip;
                            }

                            list.push( {
                                id: c.cid,
                                oid: c.cid,
                                title: c.name,
                                sub: addr,
                                extraField: 'birthday',
                                c: c
                            } );
                        }
                    }
                } );
            }

            list.sort( ( a, b ) => {
                const ad = new Date( a.c.birthday );
                const bd = new Date( b.c.birthday );
                ad.setFullYear( 2024 );
                bd.setFullYear( 2024 );
                return ad.getTime() - bd.getTime();
            } );

            const chartData = [
                { name: "Bdays", value: list.length }
            ];

            setData( ( prev ) => {
                return {
                    ...prev,
                    bdays: {
                        ...prev.bdays,
                        gridTitle: `Birthdays ${timing}`,
                        chartTitle: `${list.length}`,
                        chartData: chartData,
                        gridData: list
                    }
                };
            } );
        }
    }, [ contacts, loans, uid, viewing, e, org ] );

    // Insight Signals
    useEffect( () => {
        let list = [];
        
        const cids = [
            'con_xmdzVHpFN49izGQJV2r3c',
            'con_flQ1oEtShUKyht0fa_Uly',
            'con_a8IC8MIf-cSFy0dPLm-4r'
        ];

        const reasons = {
            'con_xmdzVHpFN49izGQJV2r3c': 'Homebot: Ran refi scencarios today',
            'con_flQ1oEtShUKyht0fa_Uly': 'Mortgage Coach: Viewed TCA multiple times yesterday',
            'con_a8IC8MIf-cSFy0dPLm-4r': 'Loan App Not Started: Email sent 2 days ago'
        }

        for ( const cid of cids ) {
            const c = contacts[cid];
            if ( c ) {
                list.push( { 
                    id: c.cid,
                    oid: c.cid,
                    title: c.name,
                    sub: reasons[cid],
                    c: c,
                } );
            }
        }
        
        
        const chartData = [
            { name: "Signals", value: list.length }
        ];

        setData( ( prev ) => {
            return {
                ...prev,
                insights2: {
                    ...prev.insights2,
                    gridTitle: 'Insight Signals',
                    chartTitle: `${list.length}`,
                    chartData: chartData,
                    gridData: list
                }
            };
        } );
    }, [ contacts ] );

    // Txt Msgs
    useEffect( () => {
        const yesterday = new Date();
        yesterday.setDate( yesterday.getDate() - 1 );

        if ( comms ) {
            let list = [];
            let show = [];

            Object.keys( comms ).forEach( cid => {
                const comm = comms[cid];

                if ( !viewing.includes( comm.aid ) ) {
                    return;
                }

                if ( comm && comm.commType === 'sms' ) {
                    const cd = new Date( comm.commDate ? comm.commDate : comm.createdDate );
                    if ( cd.getTime() < ( yesterday.getTime() - ( 1000 * 60 * 60 * 24 * 5 ) ) ) {
                        return;
                    }
                    
                    if ( comm.assoc && comm.assoc.length ) {
                        const conid = comm.assoc[0].cid;
                        const c = contacts[conid];
                        if ( c ) {
                            list.push( { 
                                id: c.cid,
                                oid: c.cid,
                                title: c.name,
                                sub: comm.details,
                                // extraField: '',
                                c: c,
                                date: cd, 
                                direction: comm.direction,
                                processed: comm.processed,
                                tstamp: formatDate( cd ),
                            } );
                        }
                    }
                }
            } );

            list.sort( ( a, b ) => {
                return ( b.date.getTime() - a.date.getTime() );
            } );
            const seen = new Set();
            list.forEach( m => {
                if ( !seen.has( m.id ) ) {
                    seen.add( m.id );
                    if ( m.direction === 'inbound' && !m.processed ) {
                        show.push( m );
                    }
                }
            } );
            
            const chartData = [
                { name: "Txt Msgs", value: show.length }
            ];

            setData( ( prev ) => {
                return {
                    ...prev,
                    insights: {
                        ...prev.insights,
                        gridTitle: 'Txt Msgs',
                        chartTitle: `${show.length}`,
                        chartData: chartData,
                        gridData: show
                    }
                };
            } );
        }
    }, [ comms, contacts, viewing ] );

    return (
        <Fragment>
            <Row className='tf-dashboard-section-header mx-2'>
                <Col className='p-2 tf-dashboard-section-header-title'>
                    <AiFillFunnelPlot />
                    <span className='ps-2'>{title}</span>
                </Col>
            </Row>
            <Row className='p-0' style={ { overflowX: 'auto' } }>
                {
                    elements.map( ( e, idx ) => (
                        <Col key={`data-${e}`} className='p-0'>
                            <TFSegment 
                                chartTitle = {data[e].chartTitle}
                                chartSub = {data[e].chartSub}
                                chartData = {data[e].chartData}
                                gridTitle = {data[e].gridTitle}
                                gridData = {data[e].gridData}
                                gridActions = {data[e].gridActions}
                            />
                        </Col>
                    ) )
                }
            </Row>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    org: state.user.org,
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    meta: state.user.meta,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    gameplan: state.gameplan.byId,
    loans: state.loans.byId,
    leadopps: state.leadopps.byId,
    comms: state.comms.byId,
    loanStatus: state.user.meta.loan.picklist.status,
    globalStatus: state.user.meta.global.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Work );